<template>
    <div class="login-box">
        <div>
            <div class="login">
                <div class="title">报名管理系统</div>
                <div class="form-box">
                    <el-form ref="form" :model="form">
                        <el-form-item class="login-input">
                            <el-input
                                    placeholder="用户名"
                                    prefix-icon="el-icon-user"
                                    v-model="form.username">
                            </el-input>
                        </el-form-item>
                        <el-form-item class="login-input">
                            <el-input
                                    class="input-style"
                                    placeholder="密码"
                                    v-model="form.password"
                                    show-password
                            >
                                <div slot="prefix" class="password-img">
                                    <img :src="require('@/assets/img/password_icon.png')" >
                                </div>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="login-input">
                            <el-input
                                    class="input-style"
                                    placeholder="图形验证码"
                                    v-model="form.verifyCode"
                                    style="width: 55%;margin-right: 20px"
                                    clearable
                            >
                                <div slot="prefix" class="vertical-img">
                                    <img :src="require('@/assets/img/code_icon.png')" >
                                </div>
                            </el-input>
                            <div @click="refreshCode">
                                <Identify :identifyCode="identifyCode"></Identify>
                            </div>
                        </el-form-item>
                        <el-form-item class="login-input">
                            <el-checkbox v-model="remember">记住密码</el-checkbox>
                        </el-form-item>
                        <el-form-item style="width: 100%;text-align: center">
                            <el-button type="primary" @click="onSubmit" style="width: 100%" round>登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Identify from '@/components/Identify.vue'
    import Utils from "../assets/js/Utils";
    import {Base64} from 'js-base64'

    export default {
        name: 'Login',
        components: {
            Identify
        },
        data() {
            return {
                form: {
                    username: null,
                    password: null,
                    verifyCode: null,
                },
                remember: false,
                identifyCodes: '1234567890',
                identifyCode: '',
            }
        },
        created() {
            if(localStorage.getItem('localUser')) {
                let localUser  = JSON.parse(localStorage.getItem('localUser'))
                this.form.username = localUser.username
                this.form.password = Base64.decode(localUser.password)
                this.remember = true
            }
        },
        mounted() {
            this.refreshCode()
        },
        methods: {

            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            refreshCode() {
                this.identifyCode = ''
                this.makeCode(this.identifyCodes, 4)
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[
                        this.randomNum(0, this.identifyCodes.length)
                        ]
                }
            },

            onSubmit() {
                if (!(/^[\u4E00-\u9FA5\uf900-\ufa2d\w\.\s]{1,18}$/.test(this.form.username))) {
                    this.$message.error('请输入正确的账号!');
                    return;
                }
                if (!(/^[\@A-Za-z0-9\!\#\$\%\^\&\*\.\~\_]{6,18}$/.test(this.form.password))) {
                    this.$message.error('请输入正确的密码!');
                    return;
                }
                if (Utils.isEmpty(this.form.verifyCode)) {
                    this.$message.error('请输入验证码!');
                    this.refreshCode()
                    return;
                } else {
                    if (this.form.verifyCode != this.identifyCode) {
                        this.$message.error('验证码不正确!');
                        this.form.verifyCode = null
                        this.refreshCode()
                        return
                    }
                }
                if(this.remember == true) {
                    // 将账户密码保存至本地
                    let params = JSON.stringify({
                        username: this.form.username,
                        password: Base64.encode(this.form.password)
                    })
                    localStorage.setItem('localUser',params)
                } else {
                    localStorage.removeItem('localUser')
                }
                axios.post(Urls.URL.login,this.form).then(res => {
                    if(res.status == '200' && res.data) {
                        let token = res.data.data.token
                        if(token) {
                            this.$store.dispatch("setToken", token)
                            if(this.$store.state.token) {
                                axios.get(Urls.URL.user_info).then(res => {
                                    if(res.status == '200') {
                                        let userInfo = res.data.data
                                        this.$store.dispatch('setUserInfo',JSON.stringify(userInfo))
                                        let menu = JSON.parse(userInfo.menuConfig)[0]
                                        switch (menu.menuItem) {
                                            case 'system.account':this.$router.push({name:'AccountManage'});this.keepAliveArray = ['AccountManage'];break
                                            case 'system.role':this.$router.push({name:'RoleManage'});this.keepAliveArray = ['RoleManage'];break
                                            case 'system.log':this.$router.push({name:'SystemLog'});this.keepAliveArray = ['SystemLog'];break
                                            case 'enroll.data':this.$router.push({name:'DataManage'});this.keepAliveArray = ['DataManage'];break
                                            case 'enroll.form':this.$router.push({name:'FormManage'});this.keepAliveArray = ['FormManage'];break
                                        }
                                    }
                                }).catch(err => {
                                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                                })
                            }

                        }
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            }
        }
    }
</script>

<style scoped lang="stylus">
    .login-box
        width 100%
        height 100%
        display flex
        background-image  url("../assets/img/background.png")
        background-size 100% 100%
        background-repeat no-repeat
        >div {
            margin 10% auto 0
        }
        .login
            width 330px
            padding 40px 20px 20px
            display flex
            flex-direction column
            background-color white
            border-radius 10px
            .title
                width 100%
                font-size 28px
                font-weight bold
                letter-spacing 2px
                color #1d78d9
                margin-bottom 10%
                text-align center
            .form-box
                .login-input
                    margin-bottom 15px
                    /deep/.el-form-item__content {
                        display flex
                    }
                    /deep/.el-checkbox
                        display flex
                        align-items center

    .input-style {
        /deep/.el-input__prefix {
            width 25px
            display flex
            justify-content center
        }
        .password-img,.vertical-img {
            width 12px
            height 14px
            >img {
                width 100%
                height 100%
            }
        }
    }

</style>
